<template>
  <main id="maincontent">
    <GlobalBreadcrumb
      v-if="!blok.removeBreadcrumb"
      :page-title="blok.overview_title"
    />
    <PageHeading
      :title="blok.overview_title"
      :subtitle="blok.overview_subtitle"
      :description="blok.overview_description"
    />
    <div
      v-for="(section, index) in blok.body"
      :key="section._uid"
      :class="`background background-${section.component}${
        index % 2 === 0 ? ' alternate' : ''
      }`"
    >
      <StoryblokComponent :blok="section" class="section" tag="section" :alternate="index % 2 === 0"/>
    </div>
  </main>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.alternate {
  @include pair-1;
  .more-help.section {
    :deep(.swiper-button-prev),
    :deep(.swiper-button-next) {
      &::before {
        background-color: var(--solid-01);
      }
    }
  }
}
</style>
